/* eslint-disable no-console */
const React = require('react');
const { createElement } = React;
const { createRoot } = require('react-dom/client');

const { REMOTE_MODULE_KEY } = require('../config/constants');

const { ModuleContext } = require('./context/ModuleContext');

function Modularize(name, Component) {
  const identifier = `${process.env.REMOTE_MODULE_APP_NAME}-${name}`; // eslint-disable-line

  window[`${REMOTE_MODULE_KEY}_${identifier}`] = {
    createRoot,
    createElement,
    ModuleContext,
    Component,
  };
}

module.exports = Modularize;
